import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';

const webserviceRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  getServiceList: (values) => api.get(`${API_URL.BASEURL}${API_URL.webGetService}`, {
    params: {
      search: values?.search
    }
  }),

  postDeleteService: (id) => api.delete(`${API_URL.BASEURL}${API_URL.webServiceDelete}?id=${id}`),
  postUpdateService: (values) => api.post(`${API_URL.BASEURL}${API_URL.webUpdateService}`, values),
  getServiceDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.webServiceDetails}?id=${id}`),
  createService: (values) => api.post(`${API_URL.BASEURL}${API_URL.webCreateService}`, values),
  
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default webserviceRequest